import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http } from '@angular/http';
import { AuthService } from './../auth/auth.service';

@Injectable()
export class BillingService {
  show: boolean = false;
  public apiUrl = environment.apiUrl;
  constructor(public http: Http, public authService: AuthService) { }

  setShow(value) {
    this.show = value;
  }

  getShow() {
    return this.show;
  }

  /*request headers*/
  public createHeaders() {
    const headers = new Headers({Accept: 'application/json'});
    if (this.authService.isLoggedIn) {
        headers.append('Authorization', 'Bearer ' + this.authService.getToken());
    }
    return headers;
}

  public retrievePlan(id) {
    return this.http
      .get(this.apiUrl + `/plan/${id}`, {headers: this.createHeaders()})
      .toPromise()
      .then(response => response.json() as any);
  }

  public retrievePlans() {
    return this.http
      .get(this.apiUrl + `/plans`, {headers: this.createHeaders()})
      .toPromise()
      .then(response => response.json() as any);
  }

  public billingCustomer(stripe_token: string) {
    return this.http
      .put(this.apiUrl + '/billing/subscription', {stripe_token}, {headers: this.createHeaders()})
      .toPromise()
      .then(response => response.json() as any)
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/billing.service.ts